<!--
  ~ Ki-Tax: System for the management of external childcare subsidies
  ~ Copyright (C) 2017 City of Bern Switzerland
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as
  ~ published by the Free Software Foundation, either version 3 of the
  ~ License, or (at your option) any later version.
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. If not, see <http://www.gnu.org/licenses/>.
  -->

<div class="batchjob-trigger-view batchjobTriggerModul admin-modul">
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <!-- Batch Jobs -->
            <div class="view-title">
                <h2>{{ 'EXECUTE_BATCHJOB' | translate }}</h2>
                <hr class="header" />
            </div>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>
                        Clean Download Files ausführen:<br />
                        Löscht alle DownloadFiles, deren Tokenlifespan
                        abgelaufen ist. Ausserdem werden alle phyischen Files im
                        Reports-Folder gelöscht, deren Tokenlifespan abgelaufen
                        ist
                    </div>
                    <dv-loading-button
                        (buttonClick)="runBatchCleanDownloadFiles()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Mahnung Prüfung ausführen</div>
                    <dv-loading-button
                        (buttonClick)="runBatchMahnungFristablauf()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>
                        Gemeinden für Institutionsstammdaten aktualisieren
                    </div>
                    <dv-loading-button
                        (buttonClick)="
                            runBatchUpdateGemeindeForBGInstitutionen()
                        "
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>
            <h2 class="margin-top-40">Export Batch Jobs</h2>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Publish existing Gemeinde Job</div>
                    <dv-loading-button
                        (buttonClick)="runBatchPublishExistingGemeinden()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Publish existing Institution Job</div>
                    <dv-loading-button
                        (buttonClick)="runBatchPublishExistingInstitutionen()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Publish existing wartende Anmeldungen Job</div>
                    <dv-loading-button
                        (buttonClick)="runBatchPublishWartendeAnmeldungen()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Publish existing wartende Betreuungen Job</div>
                    <dv-loading-button
                        (buttonClick)="runBatchPublishWartendeBetreuung()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Publish existing Gemeinde Kennzahlen Job</div>
                    <dv-loading-button
                        (buttonClick)="
                            runBatchPublishExistingGemeindeKennzahlen()
                        "
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Publish existing Verfuegung Job</div>
                    <dv-loading-button
                        (buttonClick)="runBatchMigrateVerfuegung()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>
                        Gemeinde bei offenen Pendenzen und Mitteilungen
                        benachrichtigen
                    </div>
                    <dv-loading-button
                        (buttonClick)="
                            runBatchInfoOffenePendenzenNeueMitteilungGemeinde()
                        "
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>
            <h2 class="margin-top-40">Jährlich ausgeführte Batchjobs</h2>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>
                        Gemeinde-Kennzahlen: Erstellen und Reminder versenden
                    </div>
                    <dv-loading-button
                        (buttonClick)="
                            runBatchCreateGemeindeKennzahlenAndSendReminder()
                        "
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Gemeinde-Kennzahlen: Zweiten Reminder versenden</div>
                    <dv-loading-button
                        (buttonClick)="
                            runBatchGemeindeKenzahlenSendSecondReminder()
                        "
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <h2 class="margin-top-40">Tägliche Batch Jobs</h2>

            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Abgelaufene Berechtigungen behandeln</div>
                    <dv-loading-button
                        (buttonClick)="runBatchAbgelaufeneRollen()"
                        buttonClass="margin-top-20"
                    >
                        Batchjob ausführen
                    </dv-loading-button>
                </div>
            </div>

            <!-- Manuelle Skripts ausfuehren -->
            <h2 class="margin-top-40">Manuelle Skripts ausführen</h2>
            <div class="row">
                <div class="col-md-12 margin-top-20">
                    <div>Noch kein Skript zur Auswahl</div>
                </div>
            </div>
        </div>
    </div>
</div>
